<div
  *ngFor="let alert of alerts"
  role="alert"
  class="fixed z-50 max-w-sm pr-6 gap-3 flex flex-col w-full py-6 px-4 rounded-lg z-[1000]"
  [ngClass]="getPositionClasses(alert.position)"
  [class]="getAlertClasses(alert.type)"
>
  <div class="flex flex ms-start gap-2.5">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
        clip-rule="evenodd"
      />
    </svg>
    <div>
      <h4 class="text-xl font-semibold">
        {{ alert.title }}
      </h4>

      <p class="leading-[1.2]">
        {{ alert.message }}
      </p>
    </div>
  </div>

  <button
    (click)="closeAlert(alert)"
    class="flex items-center justify-center transition-all duration-300 hover:bg-white/30 size-8 rounded-md absolute top-2 right-2 cursor-pointer"
    type="button"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="h-7 w-7"
      stroke-width="1.5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      ></path>
    </svg>
  </button>
</div>
